import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ResponseResult } from '@app/auth/model';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { ContactBySite } from '@app/admin/model';

@Injectable({
  providedIn: 'root'
})
export class ContactBySiteService {

  private route: string = "marketing";
  private controller: string = "contactbysite";
  private endpointPrefix: string;

  constructor(private http: HttpClient) {
    this.endpointPrefix = `${environment.urlAPI}/${this.route}/${this.controller}`;
  }

  getall(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/get`);
  }

  getResultGrid(crmStatus: string): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getResultGrid/${crmStatus}`);
  }

  getById(id: string): any {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/getById`, {params: params});
  }

  countByStatus(): any {
    return this.http.get<ResponseResult>(`${this.endpointPrefix}/countByStatus`);
  }
  
  remove(id): Observable<any> {
    let params = new HttpParams();
    params = params.append('id', id);
    return this.http.delete<ResponseResult>(`${this.endpointPrefix}/remove`, {params: params});
  }
  
  save(contactBySite: ContactBySite, editing: boolean = false): any {
    if (editing) { //update
      return this.http.put<ResponseResult>(`${this.endpointPrefix}/update`, contactBySite);
    } else { //new
      return this.http.post<ResponseResult>(`${this.endpointPrefix}/add`, contactBySite);
    }
  }

  changeStatus(changeStatus: any) {
    return this.http.put<ResponseResult>(`${this.endpointPrefix}/changeStatus`, changeStatus);
  }
}
